export const setPayload = ({
  driverName,
  phoneNumber,
  locationState,
  status
}) => {
  const payload = {}

  if (driverName) {
    payload.name = driverName
  }

  if (phoneNumber) {
    payload.phone_number = phoneNumber
  }

  if (locationState) {
    payload.location_state = locationState?.state_id
    payload.location_city = locationState?.city
  }

  if (status) {
    payload.status = status?.value
  }

  return payload
}

export const formatDriver = ({ status, ...driver }) => {
  const value = typeof status === 'string' ? status : status?.value || ''
  const label = status || status?.value === '0' ? 'Unavailable' : 'Available'
  return {
    status: { value, label },
    ...driver
  }
}

export const validateStore = state => {
  return !!state?.name
}

export const setRecurringPayload = ({
  originState,
  destState,
  equipmentType,
  dispatcherName
}) => {
  const payload = {}

  if (originState) {
    payload.origin_city = originState?.city || ''
    payload.origin_state = originState?.state_id || ''
  }

  if (destState) {
    payload.destination_city = destState?.city || ''
    payload.destination_state = destState?.state_id || ''
  }

  if (equipmentType) {
    payload.equipment_type = equipmentType?.equipment_code
  }

  if (dispatcherName) {
    payload.dispatcher_name = dispatcherName
  }

  return payload
}
